import React, { Component } from 'react'
import { GoogleMap, withGoogleMap, withScriptjs } from 'react-google-maps'
import mapStyles from 'assets/mapStyles.json'

const API_KEY = window._env.REACT_APP_GOOGLE_API_KEY
export const DEFAULT_CENTER = { lat: -46.92, lng: -73.125 }
export const DEFAULT_ZOOM = 8

class Map extends Component {
  render() {
    const {
      zoom,
      mapRef,
      mapZoom,
      mapCenter,
      onClick,
      onCenterChanged,
      onZoomChanged,
      positionCenter,
      children,
    } = this.props
    const defaultValues = {
      zoom: DEFAULT_ZOOM,
      defaultLatLng: DEFAULT_CENTER,
      loadingElement: <div />,
      mapElement: <div className="map-element" />,
      containerElement: <div className="map-container-element" />,
    }

    const MyGoogleMap = withScriptjs(
      withGoogleMap(() => (
        <GoogleMap
          defaultZoom={mapZoom || defaultValues.zoom}
          defaultCenter={mapCenter || defaultValues.defaultLatLng}
          options={{
            mapTypeControl: false,
            mapTypeControlOptions: {
              style: window.google.maps.MapTypeControlStyle.DEFAULT,
              mapTypeIds: ['roadmap', 'satellite'],
            },
            zoomControl: true,
            fullscreenControl: false,
            scaleControl: true,
            disableDefaultUI: true,
            styles: mapStyles,
          }}
          onClick={onClick}
          onCenterChanged={onCenterChanged}
          onZoomChanged={onZoomChanged}
          ref={mapRef}>
          {children}
        </GoogleMap>
      )),
    )

    return (
      <MyGoogleMap
        googleMapURL={`https://maps.googleapis.com/maps/api/js?v=3.exp&key=${API_KEY}`}
        loadingElement={defaultValues.loadingElement}
        containerElement={defaultValues.containerElement}
        mapElement={defaultValues.mapElement}
        mapZoom={zoom}
        mapCenter={positionCenter}
      />
    )
  }
}

export default Map
